import React from 'react';

import {GetStaticPaths, GetStaticProps} from 'next';
import Head from 'next/head';

import {Sprint} from 'src/components/sprint';
import {regionalConfigsArr} from 'src/config';
import {PageParams} from 'src/types';

interface SpeedPageProps {
  region: string;
  locale: string;
}

export const getStaticPaths: GetStaticPaths<PageParams> = async () => {
  const paths: {params: PageParams}[] = [];

  for (const config of regionalConfigsArr) {
    const {locales, regionCode: region} = config;
    for (const locale of locales) {
      paths.push({params: {region, locale}});
    }
  }

  return {paths, fallback: false};
};

export const getStaticProps: GetStaticProps<
  SpeedPageProps,
  PageParams
> = async (ctx) => {
  const {params} = ctx;

  if (!params) {
    throw new Error('Could not find URL page params for speed page');
  }

  const {region, locale} = params;

  return {props: {region, locale}};
};

const title = 'Stryd Speed — Every step. Every rep. Measured.';
const description =
  'Speed, ground contact, air time, and stride mechanics — at every step, on every surface. ' +
  'Captured, cut into reps, and ready before your athlete is back on the line.';

const SpeedPage = ({region, locale}: SpeedPageProps): JSX.Element => {
  const homeHref = `/${region}/${locale}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <Sprint homeHref={homeHref} />
    </>
  );
};

export default SpeedPage;
